/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Frame_Back_TitleInputs */



/**
* | output |
* | --- |
* | "Frame Back" |
*
* @param {Player_Frame_Back_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_frame_back_title = /** @type {((inputs?: Player_Frame_Back_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Frame_Back_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Image Precedente")
	if (locale === "de") return /** @type {LocalizedString} */ ("Rahmenrückseite")
	if (locale === "it") return /** @type {LocalizedString} */ ("Telaio posteriore")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Рамка сзади")
	if (locale === "es") return /** @type {LocalizedString} */ ("Marco trasero")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("框架背面")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フレームバック")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ्रेम का पिछला भाग")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Parte traseira da moldura")
	return /** @type {LocalizedString} */ ("Frame Back")
});